import { Moment } from "moment";
import { OfficeEntity } from "@features/desks/services/AdvanceHotDeskingService";
import { agent } from "@shared/services/agent";
import { DATE_FORMAT } from "@shared/utils/DateUtils";

export function getVisitorReport(office: OfficeEntity | undefined, dateFrom: Moment, dateTo: Moment): Promise<VisitorReport> {
  const officeParam = office ? `officeId=${office.id}&` : '';
  return agent.requests.get(`/api/report/visitors?${officeParam}fromDate=${dateFrom.format(DATE_FORMAT)}&toDate=${dateTo.format(DATE_FORMAT)}`);
}

export type VisitorSignInState = 'NONE' | 'CHECKED_IN' | 'CHECKED_OUT';

export interface VisitorReportLine {
  bookingId: number;
  date: string;
  timeDue: string;
  visitorName: string;
  companyName: string | null;
  email: string | null;
  hostName: string | null;
  hostTeamName: string | null;
  officeId: number | null;
  officeLabel: string | null;
  signInState: VisitorSignInState;
  checkedInAt: string | null;
  checkedInBy: string | null;
  checkedOutAt: string | null;
  checkedOutBy: string | null;
  amDeskBooked: boolean;
  pmDeskBooked: boolean;
  amParkingBooked: boolean;
  pmParkingBooked: boolean;
}

export interface VisitorDailyCount {
  date: string;
  visitors: number;
  checkedIn: number;
}

export interface VisitorReport {
  officeId: number | null;
  officeLabel: string;
  fromDate: string;
  toDate: string;
  totalVisitors: number;
  checkedIn: number;
  checkedOut: number;
  notCheckedIn: number;
  dailyBreakdown: VisitorDailyCount[];
  visitors: VisitorReportLine[];
}
